export const ABOUT_US_LINK = 'https://www.withplenty.com/about';
export const HELP_CENTER_LINK = 'https://helpcenter.withplenty.com/hc/en-us';
export const LEGAL_LINK = 'https://www.withplenty.com/legal';
export const DISCLOSURES_LINK =
    'https://www.withplenty.com/legal#generaldisclosures';
export const TERMS_OF_SERVICE_LINK =
    'https://www.withplenty.com/legal#termsofservice';
export const PRIVACY_POLICY_LINK =
    'https://www.withplenty.com/legal#privacypolicy';
